'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactPlayerFork = require('react-player-fork');

var _reactPlayerFork2 = _interopRequireDefault(_reactPlayerFork);

var _utils = require('../../../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoItem = function (_React$Component) {
  (0, _inherits3.default)(VideoItem, _React$Component);

  function VideoItem(props) {
    (0, _classCallCheck3.default)(this, VideoItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VideoItem.__proto__ || (0, _getPrototypeOf2.default)(VideoItem)).call(this, props));

    _this.pause = _this.pause.bind(_this);
    _this.play = _this.play.bind(_this);
    _this.state = {
      playedOnce: false,
      playing: false
    };
    return _this;
  }

  (0, _createClass3.default)(VideoItem, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.playing) {
        this.setState({ playedOnce: true });
      }
    }
  }, {
    key: 'play',
    value: function play() {
      this.props.playVideo(this.props.idx);
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.props.pauseVideo();
    }

    //-----------------------------------------| UTILS |--------------------------------------------//

  }, {
    key: 'createPlayerElement',
    value: function createPlayerElement() {
      var _this2 = this;

      //video dimensions are for videos in grid fill - placing the video with negative margins to crop into a square
      var isWiderThenContainer = this.props.style.ratio >= this.props.cubeRatio;

      var videoDimensionsCss = {
        width: isWiderThenContainer ? '100%' : 'auto',
        height: isWiderThenContainer ? 'auto' : '100%'
      };

      if (this.props.styleParams.cubeImages && this.props.styleParams.cubeType === 'fill') {
        var _ref = [videoDimensionsCss.height, videoDimensionsCss.width]; //grid crop mode

        videoDimensionsCss.width = _ref[0];
        videoDimensionsCss.height = _ref[1];

        videoDimensionsCss.position = 'absolute';
        videoDimensionsCss.margin = 'auto';
        videoDimensionsCss.minHeight = '100%';
        videoDimensionsCss.minWidth = '100%';
        videoDimensionsCss.left = '-100%';
        videoDimensionsCss.right = '-100%';
        videoDimensionsCss.top = '-100%';
        videoDimensionsCss.bottom = '-100%';
      }
      return _react2.default.createElement(_reactPlayerFork2.default, {
        className: 'gallery-item-visible video gallery-item',
        width: '100%',
        height: '100%',
        onReady: this.props.actions.setItemLoaded,
        url: this.props.videoUrl ? this.props.videoUrl : this.props.resized_url.mp4,
        loop: !!this.props.styleParams.videoLoop,
        ref: function ref(player) {
          return _this2.video = player;
        },
        volume: this.props.styleParams.videoSound ? 0.8 : 0,
        playing: this.props.playing,
        poster: this.props.resized_url.img,
        mockPlayer: !this.state.playedOnce && (this.props.isExternalVideo || _utils2.default.isMobile()),
        onEnded: function onEnded() {
          _this2.setState({ playing: false });
          _this2.props.onEnd();
        },
        onPause: function onPause() {
          _this2.setState({ playing: false });
        },
        playbackRate: this.props.styleParams.videoSpeed || 1,
        onPlay: function onPlay() {
          _this2.setState({ playing: true });
        },
        fileConfig: {
          attributes: {
            muted: !this.props.styleParams.videoSound,
            preload: 'metadata',
            poster: this.props.resized_url.img,
            style: videoDimensionsCss
          }
        },
        key: 'video-' + this.props.id
      });
    }
  }, {
    key: 'createImageElement',
    value: function createImageElement() {
      var _this3 = this;

      return _react2.default.createElement('img', { ref: function ref(img) {
          // onLoad replacement for SSR
          if (!img) {
            return;
          }
          img.onload = _this3.props.actions.setItemLoaded; //initializing onLoad for further calls
          if (img.complete && !_this3.props.loadingStatus.loaded) {
            _this3.props.actions.setItemLoaded(); //first call, will not be called again because if it was called once loadingStatus.loaded will be true
          }
        },
        onError: this.props.actions.setItemError,
        key: 'image-' + this.props.id,
        className: 'gallery-item-hidden gallery-item-visible gallery-item ' + (this.props.loadingStatus.loaded ? ' gallery-item-loaded ' : '') + (this.props.loadingStatus.failed ? ' failed ' : ''),
        src: this.props.resized_url.img
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onMount(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onUnmount();
    }
  }, {
    key: 'canVideoPlayInGallery',
    value: function canVideoPlayInGallery(itemClick, videoPlay) {
      if (_utils2.default.isMobile() && itemClick !== 'expand') return true;else if (!_utils2.default.isMobile() && itemClick !== 'expand') return true;else if (!_utils2.default.isMobile() && videoPlay !== 'onClick') return true;else return false;
    }

    //-----------------------------------------| RENDER |--------------------------------------------//

  }, {
    key: 'render',
    value: function render() {
      var baseClassName = 'gallery-item-content gallery-item-visible gallery-item-preloaded gallery-item-video gallery-item' + (_utils2.default.isiPhone() ? ' ios' : '') + (this.props.loaded ? 'gallery-item-loaded' : '');
      if (this.state.playing) {
        baseClassName += ' playing';
      }
      var videoControls = this.props.hidePlay ? false : [_react2.default.createElement('i', { key: 'play-triangle', 'data-hook': 'play-triangle', className: 'gallery-item-video-play-triangle progallery-svg-font-icons-play-triangle ' }), _react2.default.createElement('i', { key: 'play-bg', 'data-hook': 'play-background', className: 'gallery-item-video-play-background progallery-svg-font-icons-play-background ' })];

      var videoPreloader = _react2.default.createElement('div', { className: 'pro-circle-preloader', key: 'video-preloader-' + this.props.idx });

      var _ref2 = this.props.imageDimensions || {},
          marginLeft = _ref2.marginLeft,
          marginTop = _ref2.marginTop,
          restOfDimensions = (0, _objectWithoutProperties3.default)(_ref2, ['marginLeft', 'marginTop']);

      var _props$styleParams = this.props.styleParams,
          videoPlay = _props$styleParams.videoPlay,
          itemClick = _props$styleParams.itemClick;

      var video = this.canVideoPlayInGallery(itemClick, videoPlay) ? _react2.default.createElement(
        'div',
        {
          className: baseClassName + ' animated fadeIn ',
          'data-hook': 'video_container-video-player-element',
          key: 'video_container-' + this.props.id,
          style: this.props.loaded || _utils2.default.deviceHasMemoryIssues() ? {} : (0, _extends3.default)({ backgroundImage: 'url(' + this.props.resized_url.thumb + ')' }, restOfDimensions)
        },
        this.createPlayerElement(),
        videoControls,
        videoPreloader
      ) : _react2.default.createElement(
        'div',
        {
          className: baseClassName,
          'data-hook': 'video_container-image-element',
          key: 'video_container-' + this.props.id,
          style: (0, _extends3.default)({ backgroundImage: 'url(' + this.props.resized_url.thumb + ')' }, this.props.imageDimensions)
        },
        this.createImageElement(),
        videoControls,
        videoPreloader
      );

      var hover = this.props.hover;

      return _react2.default.createElement(
        'div',
        { key: 'video-and-hover-container' + this.props.idx
        },
        [video, hover]
      );
    }
  }]);
  return VideoItem;
}(_react2.default.Component);

exports.default = VideoItem;